import { LicenseInfo } from '@mui/x-data-grid-premium';

LicenseInfo.setLicenseKey('0a80b83d65f2826da3637e148dad3881Tz0xMTgxODAsRT0xNzg3Nzg4Nzk5MDAwLFM9cHJlbWl1bSxMTT1zdWJzY3JpcHRpb24sUFY9aW5pdGlhbCxLVj0y');

export * from './materialDataGrid';
export * from '@mui/x-data-grid-premium';
